import React from 'react'
import Collapsible from 'react-collapsible';
import Border from '../Border'

import PortalModal from "./PortalModal"

import { IconAndSVGPicker } from '../IconPickerGrid';

import { IconsMind } from "../../utils/IconsMind"
import { MaterialIcons } from "../../utils/MaterialIcons"
import { updateIconType } from '../constants/utils';

export default class IconPickerModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      show: props.show,
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render() {
    let {
      show,
    } = this.state
    let { currentIcon, useCondition } = this.props
    return (
      <PortalModal
        show={show}
        id='icon-picker-modal'
        onHide={() => this.props.onHide()}
      >
        <style>
          {
            `
              .modal-container {
                z-index: 1006 !important;
              }
            `
          }
        </style>
        <IconAndSVGPicker
          type={this.props.type}
          hideDisplayIcon={true}
          currentIcon={currentIcon}
          iconPickerLabel="Icons"
          iconPickerClassName="r-custom-grid-height"
          iconPickerCancel={() => this.props.onHide()}
          onSelected={(actionType, actionValue) => {
            if (actionType === "svg") {
               this.props.onSelected(actionType, actionValue, true)
            } else if (actionType === 'type') {
              this.props.onSelected(actionValue, updateIconType(currentIcon, actionValue), false, true)
            } else {
              let value = ""
              if (useCondition === "fa-check") {
                if(actionValue.icon.startsWith("fa-")) {
                  value = `${actionValue.icon} icon--lg`
                } else {
                  value = "icon icon--lg icon-" + actionValue.name
                }
              } else {
                value = "icon-" + actionValue.name
              }
              this.props.onSelected(actionType, value, true)
            }
          }}
        />
      </PortalModal>
    )
  }
}

IconPickerModal.defaultProps = {
    message: null,
    loading: false,
    type: "iconsmind"
}
